module.exports = __webpack_public_path__ + "static/media/reedContentLJ1021.f2d6d634.ico";